import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@mui/material';
// import HeaderText from '../../UI/Headers/HeaderText';

// Styles
const useStyles = makeStyles((theme) => ({
  video: {
    display: 'inline-block',
    marginBottom: 50,
    height: 600,
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
    [theme.breakpoints.between('0', '450')]: {
      display: 'none',
    },
  },
  mobileVideo: {
    marginBottom: 50,
    height: 600,
    display: 'none',
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
    [theme.breakpoints.between('0', '450')]: {
      display: 'inline-block',
    },
  },
}));

const CareerVideo = (props) => {
  const classes = useStyles();
  const { data } = props;

  return (
    <Grid container alignItems="flex-start">
      <Grid item xs={12}>
        <video muted autoPlay loop className={classes.video} width="100%" height="100%" style={{ objectFit: 'cover' }}>
          <source src={data ? data.careerOpportunitiesVideo.url : '/'} />
        </video>
        <video muted autoPlay loop className={classes.mobileVideo} width="100%" height="100%" style={{ objectFit: 'cover' }}>
          <source src={data ? data.careerOpportunitiesVideoMobile.url : '/'} />
        </video>
      </Grid>
    </Grid>
  );
};

export default CareerVideo;
